import React from 'react';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import '../i18n';
import { RatingStarsProps } from '../types';

const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: 'red'
    },
    '&.Mui-disabled': {
        opacity: 1
    },
    '&.Mui-disabled .MuiRating-iconEmpty': {
        opacity: 0.2
    },
    '& .MuiRating-iconEmpty': {
        color: 'red',
        opacity: .5
    },
    '& .MuiRating-iconHover': {
        color: 'red'
    }
});

const RatingStars: React.FC<RatingStarsProps> = ({ rating, clientRating, onRatingChange, onClick, ratingInactive, legend, buttonDisabled, rated }) => {
    const { t } = useTranslation();

    return (
        <>
            <StyledRating
                name="half-rating"
                size="large"
                value={rating}
                precision={0.5}
                disabled={ratingInactive}
                onChange={onRatingChange}
            />
            <Typography component="legend" sx={{ fontWeight: 'bold' }}>{legend}</Typography>
            {rated
                ? (
                    <span>{t('rated_text')} {clientRating}</span>
                )
                : (
                    <Button
                        variant="outlined"
                        disabled={buttonDisabled}
                        onClick={onClick}
                        color="error"
                        size="medium"
                    >
                        {t('rating_button_text')}
                    </Button>
                )}
        </>
    );
};

export default RatingStars;
